import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import { getEntityByName } from '../appEntities';
import {
    PAYOUT_RECIPIENT_LOAD,
    PAYOUT_RECIPIENT_SUCCESS,
    PAYOUT_RECIPIENT_FAILURE
} from './payoutRecipientActions';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
    let newState;

    switch (action.type) {
        case PAYOUT_RECIPIENT_LOAD:
            newState = {
                ...state,
                recipient: null,
                isRecipientLoading: true,
                recipientError: null
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_RECIPIENT_SUCCESS:
            newState = {
                ...state,
                isRecipientLoading: false,
                recipient: action.recipient
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_RECIPIENT_FAILURE:
            newState = {
                ...state,
                recipientError: action.error,
                isRecipientLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getRecipientEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'payoutRecipient')
);

export const getIsRecipientLoading = createSelector(
    getRecipientEntity,
    (entity) => get(entity, 'isRecipientLoading')
);

export const getRecipientError = createSelector(
    getRecipientEntity,
    (entity) => get(entity, 'recipientError')
);

export const getRecipientErrorMessage = createSelector(
    getRecipientError,
    (error) => get(error, 'message')
);

export const getRecipient = createSelector(
    getRecipientEntity,
    (entity) => get(entity, 'recipient')
);
